import type { TourStep } from "@/components/GuidedTour";

export const affiliateDashboardTourSteps: TourStep[] = [
  {
    target: "aff-header",
    title: "Welcome to Your Affiliate Dashboard",
    titleAr: "مرحباً بك في لوحة تحكم الشريك",
    description: "This is your command center as a referral partner. From here you can manage clients, create campaigns on their behalf, and track every commission you earn.",
    descriptionAr: "هذا هو مركز التحكم الخاص بك كشريك إحالة. من هنا يمكنك إدارة العملاء، وإنشاء الحملات نيابة عنهم، وتتبع كل عمولة تكسبها.",
  },
  {
    target: "aff-stats",
    title: "Your Performance at a Glance",
    titleAr: "أداؤك في لمحة",
    description: "These cards show your live totals — total sales, commissions earned, active clients, and bookings. They update automatically as you work.",
    descriptionAr: "تعرض هذه البطاقات إجمالياتك المباشرة — إجمالي المبيعات، العمولات المكتسبة، العملاء النشطون، والحجوزات. تتحدث تلقائياً أثناء عملك.",
  },
  {
    target: "aff-nav",
    title: "Dashboard Navigation",
    titleAr: "تنقل لوحة التحكم",
    description: "Use the sidebar to switch between Overview, Bookings, Clients, Commissions, Create Campaign, Profile, and Support.",
    descriptionAr: "استخدم الشريط الجانبي للتنقل بين النظرة العامة، الحجوزات، العملاء، العمولات، إنشاء حملة، الملف الشخصي، والدعم.",
  },
  {
    target: "aff-overview",
    title: "Overview & Quick Actions",
    titleAr: "نظرة عامة وإجراءات سريعة",
    description: "The overview shows your monthly earnings chart and quick shortcuts to create a campaign or add a client without leaving the page.",
    descriptionAr: "تعرض النظرة العامة مخطط أرباحك الشهرية واختصارات سريعة لإنشاء حملة أو إضافة عميل دون مغادرة الصفحة.",
  },
  {
    target: "aff-create",
    title: "Create Campaigns for Clients",
    titleAr: "إنشاء حملات للعملاء",
    description: "Book DOOH campaigns on behalf of your clients. You manage the relationship — we handle the booking, payment, and delivery.",
    descriptionAr: "احجز حملات DOOH نيابة عن عملائك. أنت تدير العلاقة — ونحن نتولى الحجز والدفع والتنفيذ.",
  },
  {
    target: "aff-clients",
    title: "Manage Your Clients",
    titleAr: "إدارة عملائك",
    description: "Clients are added automatically when you create campaigns for them. You can also add or edit clients manually here.",
    descriptionAr: "تتم إضافة العملاء تلقائياً عند إنشاء حملات لهم. يمكنك أيضاً إضافة أو تعديل العملاء يدوياً من هنا.",
  },
  {
    target: "aff-commissions",
    title: "Track Commissions",
    titleAr: "تتبع العمولات",
    description: "See every commission you've earned, its status (pending, confirmed, or paid), and follow your payouts in one place.",
    descriptionAr: "اطلع على كل عمولة كسبتها، وحالتها (قيد الانتظار، مؤكدة، أو مدفوعة)، وتابع مدفوعاتك في مكان واحد.",
  },
  {
    target: "tour-help-button",
    title: "Need Help?",
    titleAr: "تحتاج مساعدة؟",
    description: "You can replay this guide anytime from this help button. Welcome aboard, partner!",
    descriptionAr: "يمكنك إعادة تشغيل هذا الدليل في أي وقت من زر المساعدة هذا. أهلاً بك يا شريكنا!",
  },
];
